export default (function (value) {
  if (value < 1000) {
    // 900 = $900
    return value;
  } else if (value < 1000000) {
    // 10,000 = $10K
    // 9,000,000 = $900K
    return "".concat(value / 1000, "K");
  } else if (value < 1000000000) {
    // 10,000,000 = $10M
    // 900,000,000 = $900M
    return "".concat(value / 1000 / 1000, "M");
  } // 10,000,000,000 = $10B
  // 900,000,000,000 = $900B


  return "".concat(value / 1000 / 1000, "B");
});